// Comprehensive terpene encyclopedia data

export const TERPENES = [
  {
    id: "mircen",
    name: "β-myrcen",
    shortName: "Mircen",
    emoji: "🥭",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/f521ab529_289693d7d_JaowiecV112_96.png",
    scent: "Ziemisty, piżmowy, ziołowy z nutami mango i goździka",
    boilingPoint: 168,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Mango", "Chmiel (piwo)", "Trawa cytrynowa", "Tymianek", "Bazylia"],
    effects: [
      "Działa uspokajająco i zmniejsza napięcie mięśniowe",
      "Zmniejsza ból — uruchamia naturalne mechanizmy przeciwbólowe organizmu",
      "Zmniejsza stan zapalny",
      "Nasenny - skraca czas zasypiania i wydłuża sen",
      "Może chronić skórę przed utratą kolagenu (na razie tylko badania laboratoryjne)",
      "Chroni komórki mózgu — bada się to w kontekście choroby Alzheimera",
      "Chroni żołądek — przed alkoholem, lekami przeciwbólowymi, bakterią H. pylori i stresem",
      "Wbrew szeroko rozpowszechnionemu mitowi mircen nie zwiększa przepuszczalności bariery krew-mózg."
    ],
    description: "Mircen jest najczęściej spotykanym terpenem w konopiach i to właśnie jemu wiele odmian indica zawdzięcza charakterystyczny, ziemisty i piżmowy aromat. Badania potwierdzają jego szerokie spektrum działania przeciwbólowego - powoduje on wydzielanie endogennych opioidów, blokadę receptorów bólowych i pośrednio oddziałowuje na receptory CB1. Mircen nie jest jednak związany wyłącznie z konopiami — występuje również jako główny składnik olejku z trawy cytrynowej, który w tradycyjnej medycynie brazylijskiej od wieków stosowany był jako naturalny środek uspokajający i przeciwbólowy.",
    color: "emerald"
  },
  {
    id: "limonen",
    name: "D-limonen",
    shortName: "Limonen",
    emoji: "🍋",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/d968a542a_6f6e78e8c_JaowiecV114_96.png",
    scent: "Cytrusowy, świeży, pomarańczowy z nutami cytryny",
    boilingPoint: 176,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Skórka cytryny i pomarańczy", "Grejpfrut", "Mandarynka", "Jałowiec"],
    effects: [
      "Łagodzi lęk, w tym niepokój po zbyt dużej dawce THC",
      "Sam zapach limonenu pobudza układ współczulny — u zwierząt podnosił ciśnienie i aktywność nerwów współczulnych, działając aktywizująco",
      "Sam również działa przeciwlękowo",
      "Zmniejsza stan zapalny",
      "Poprawia nastrój i samopoczucie",
      "Chroni błonę śluzową żołądka i przełyku",
      "Redukuje komórki tłuszczowe i trójglicerydy",
      "Chroni komórki nerwowe",
      "Utleniony limonen może uczulać — dlatego susz warto trzymać w szczelnym opakowaniu, w chłodzie i bez dostępu światła",
      "Może powodować podrażnienie górnych dróg oddechowych — w Unii Europejskiej α-pinen i d-limonen figurują wśród pięciu zanieczyszczeń powietrza istotnych dla układu oddechowego."
    ],
    description: "Limonen to jeden z najpowszechniej występujących terpenów w przyrodzie, a w wielu odmianach konopi pełni rolę dominującego składnika profilu aromatycznego — to właśnie jemu zawdzięczamy świeży, cytrusowy zapach kojarzony z niektórymi suszonymi kwiatami. Jego znaczenie wykracza jednak poza aromat: badania kliniczne wskazują na realny potencjał limonenu w łagodzeniu objawów lęku i depresji. Co więcej, limonen działa jako naturalny wzmacniacz wchłaniania — zwiększa przenikanie substancji czynnych podanych miejscowo. Warto zauważyć, że ta sama właściwość leży prawdopodobnie u podstaw działania uczulającego limonenu.",
    color: "yellow"
  },
  {
    id: "kariofilen",
    name: "β-Kariofilen",
    shortName: "Kariofilen",
    emoji: "🌶️",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/632dd4c09_0a07acb65_JaowiecV111_96.png",
    scent: "Pikantny, pieprzowy, korzenny z nutami goździka i drewna",
    dateAdded: "2026-08-23",
    boilingPoint: 263,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Czarny pieprz", "Goździki", "Cynamon", "Oregano", "Bazylia"],
    effects: [
      "Działa na receptor kannabinoidowy CB2 — czyli na ten sam układ co THC, ale na jego drugą część, obecną głównie w komórkach odporności, a nie w mózgu.",
      "Silnie przeciwzapalny, łagodzi m.in. atopowe zapalenie skóry.",
      "Łagodzi zapalenie jelita grubego, zmniejszając nasilenie choroby i uszkodzenie ściany jelita.",
      "Przyspiesza gojenie się ran.",
      "Przeciwbólowy, szczególnie w bólu zapalnym i w bólu z uszkodzenia nerwów — w tym w neuropatii po chemioterapii i w cukrzycy. Przy długim podawaniu zwierzętom jego działanie nie słabło, czyli nie rozwijała się tolerancja. W modelach bólu pooperacyjnego i fibromialgii działał przez inny układ, receptory adenozynowe, ale był tam najsłabszy z badanych terpenów.",
      "Poprawia nastrój, działa na te same szlaki co leki przeciwdepresyjne",
      "Chroni komórki nerwowe — m.in. po udarze, w stwardnieniu rozsianym i chorobach neurodegeneracyjnych",
      "Chroni żołądek — u zwierząt zmniejszał uszkodzenia błony śluzowej po lekach przeciwbólowych i hamował wzrost bakterii Helicobacter pylori."
    ],
    description: "Spośród wszystkich terpenów obecnych w konopiach kariofilen zajmuje wyjątkowe miejsce — jako jedyny bezpośrednio aktywuje receptory endokannabinoidowe CB2, co czyni go czymś więcej niż tylko składnikiem aromatycznym. Dzięki temu mechanizmowi wykazuje silne właściwości przeciwzapalne, nie wywołując przy tym żadnych efektów psychoaktywnych. Kariofilen nie jest zresztą związkiem charakterystycznym wyłącznie dla konopi — występuje również jako jeden z głównych składników olejku z czarnego pieprzu i goździków, skąd pochodzi jego korzenny, pieprzowy aromat.",
    color: "orange"
  },
  {
    id: "terpinolen",
    name: "Terpinolen",
    shortName: "Terpinolen",
    emoji: "🌲",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/50730cec4_5a931a49c_JaowiecV12_96.png",
    scent: "Sosnowy, kwiatowy, ziołowy z nutami cytrusowymi i lekko słodkimi",
    boilingPoint: 185,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Szałwia", "Rozmaryn", "Drzewo herbaciane", "Gałka muszkatołowa", "Sosna"],
    effects: [
      "Zwiększa czujność, napęd i koncentrację",
      "Działa przeciwbakteryjnie i przeciwgrzybiczo",
      "Zmniejsza stan zapalny i może wzmacniać działanie ibuprofenu czy ketoprofenu"
    ],
    description: "Terpinolen rzadko dominuje w profilu terpenowym konopi, jednak gdy tak się dzieje, jego obecność jest nie do przeoczenia. Nadaje odmianie wyraźny, sosnowo-ziołowy charakter z cytrusową nutą, który odróżnia go od bardziej pospolitych terpenów. Terpinolen jest szczególnie charakterystyczny dla odmian sativa o pobudzającym działaniu — to właśnie on w dużej mierze odpowiada za profil aromatyczny i efekt takich odmian jak Ghost Train Haze czy Jack Haze, dostępnych również na polskim rynku.",
    color: "teal"
  },
  {
    id: "pinen",
    name: "α-Pinen",
    shortName: "Pinen",
    emoji: "🌲",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/bc3b4c6c2_e696f39ce_JaowiecV13_96.png",
    scent: "Sosnowy, iglasty, świeży, żywiczny",
    dateAdded: "2026-08-23",
    boilingPoint: 155,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Igły sosnowe", "Rozmaryn", "Bazylia", "Żywica drzew iglastych"],
    effects: [
      "Zmniejsza stan zapalny",
      "Właściwości przeciwbólowe, szczególnie w bólu zapalnym",
      "Wykazuje działanie pomocnicze w terapii łuszczycy",
      "Przyspiesza gojenie ran",
      "Chroni żołądek i zmniejsza wydzielanie kwasu",
      "Zmniejsza napięcie i lęk",
      "Nasenny, wydłuża sen i ułatwia zasypianie, nie wpływa na głębokość snu.",
      "Nasila skurcz tchawicy i może powodować podrażnienie górnych dróg oddechowych — w Unii Europejskiej α-pinen i d-limonen figurują wśród pięciu zanieczyszczeń powietrza istotnych dla układu oddechowego."
    ],
    description: "Pinen to terpen, który dosłownie otacza nas w naturze — jest najczęściej występującym terpenem na Ziemi, a swoją nazwę zawdzięcza sośnie, w której gromadzi się w wyjątkowo dużych ilościach. W konopiach pełni rolę składnika uzupełniającego profil aromatyczny o świeże, leśne nuty. Pinenowi przez lata przypisywano zdolność łagodzenia zaburzeń pamięci krótkotrwałej po THC. Była to jednak hipoteza, a nie wynik badania. Gdy w 2025 roku sprawdzono ją u ludzi w badaniu z waporyzowanym THC i α-pinenem w trzech dawkach, pinen nie złagodził zaburzeń pamięci w żadnej z nich, i jego działanie nie różniło się od placebo.",
    color: "green"
  },
  {
    id: "linalol",
    name: "Linalol",
    shortName: "Linalol",
    emoji: "🌹",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/556102466_61821d4b7_JaowiecV14_96.png",
    scent: "Kwiatowy, lawendowy, lekko korzenny z nutami cytrusów",
    dateAdded: "2026-08-23",
    boilingPoint: 198,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Lawenda", "Kolendra (nasiona)", "Mięta pieprzowa", "Cynamon", "Brzoza", "Bazylia", "Róża"],
    effects: [
      "Łagodzi objawy migreny i obniża poziom mediatorów uczestniczących w jej mechanizmach.",
      "Uspokaja i zmniejsza lęk",
      "Wykazuje działanie przeciwzapalne",
      "Przeciwdrgawkowy i przeciwpadaczkowy",
      "Analgetyczny (przeciwbólowy), szczególnie w bólu zapalnym, fibromialgii, neuropatycznym i pooperacyjnym",
      "Nasenny — ułatwia zasypianie i wydłuża sen (dane z badań na zwierzętach; u ludzi jakość snu udokumentowano dla olejku lawendowego i mieszanek CBD z terpenami, nie dla samego linalolu)",
      "Chroni komórki nerwowe — w modelu choroby Alzheimera poprawiał pamięć i zmniejszał zmiany w mózgu",
      "Chroni komórki serca — w modelu zawału ogranicza obszar uszkodzenia mięśnia sercowego",
      "Chroni wątrobę i nerki",
      "Jego utlenione związki mogą wywoływać reakcje alergiczne"
    ],
    description: "Linalol to terpen, którego działanie większość z nas zna, choć niekoniecznie zna jego nazwę — to właśnie on odpowiada za kojący, kwiatowy zapach lawendy, od wieków wykorzystywanej w aromaterapii jako naturalny środek uspokajający. W konopiach pełni analogiczną rolę, a jego właściwości nie są jedynie kwestią tradycji czy subiektywnych odczuć. Badania wykazały, że samo wdychanie linalolu wystarczy, by wymiernie obniżyć poziom lęku — i co istotne, dzieje się to bez żadnego wpływu na zdolności motoryczne, co odróżnia go od wielu klasycznych środków uspokajających",
    color: "purple"
  },
  {
    id: "humulen",
    name: "α-Humulen",
    shortName: "Humulen",
    emoji: "🍺",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/af9fb90a5_6f98e94bb_JaowiecV113_96.png",
    scent: "Ziemisty, drzewny, korzenny z nutami chmielu",
    dateAdded: "2026-08-23",
    boilingPoint: 276,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Chmiel (piwo)", "Szałwia", "Kolendra", "Goździki", "Bazylia", "Ginseng"],
    effects: [
      "Gastroprotekcyjny (ochronny dla błony śluzowej żołądka)",
      "Silnie przeciwzapalny, porównywalnie ze sterydem",
      "Analgetyczny (przeciwbólowy), szczególnie w bólu zapalnym, neuropatycznym, pooperacyjnym i w fibromialgii (dane z badań na zwierzętach)",
      "Działa ochronnie na płuca, zmniejsza wydzielanie wydzieliny i stan zapalny u astmatyków",
      "Wbrew licznym zapewnieniom w internecie humulen nie zmniejsza apetytu — właściwość chmielu, a ściślej goryczki, czyli izo-α-kwasów, nagminnie przypisuje się samemu terpenowi."
    ],
    description: "Humulen, znany również jako α-kariofilen, jest strukturalnym izomerem β-kariofilenu i w konopiach niemal zawsze towarzyszy swojemu bliźniaczemu związkowi. Poza konopiami znany jest przede wszystkim jako główny terpen chmielu, któremu nadaje charakterystyczny, ziemisty i lekko drzewny aromat. W kontekście terapeutycznym wyróżnia go zdolność do bezpośredniego hamowania uwalniania histaminy z komórek tucznych, a jego działanie przeciwzapalne należy do najlepiej udokumentowanych wśród terpenów konopnych.",
    color: "amber"
  },
  {
    id: "ocymen",
    name: "Ocymen",
    shortName: "Ocymen",
    emoji: "🌿",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/7b9827d77_69adbe4e0_JaowiecV116_96.png",
    scent: "Słodki, ziołowy, drzewny z nutami cytrusowymi i lekko słodkimi",
    dateAdded: "2026-08-23",
    boilingPoint: 177,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Mięta", "Pietruszka", "Bazylia", "Mango", "Orchidee", "Kumkwat"],
    effects: [
      "Gastroprotekcyjny, w badaniach na zwierzętach chroni błonę śluzową żołądka przed niesteroidowymi lekami przeciwzapalnymi.",
      "Przeciwbólowy",
      "Zmniejsza stan zapalny",
      "Neuroprotekcyjny w modelu ch. Parkinsona na zwierzętach",
      "U myszy wdychany ocymen nasilał zachowania lękowe"
    ],
    description: "Ocymen to terpen o delikatnym, słodkim aromacie z ziołową i lekko kwiatową nutą, dobrze znany z olejków eterycznych mięty i bazylii, gdzie należy do charakterystycznych składników zapachowych. W konopiach pełni rolę uzupełniającą profil aromatyczny, rzadko dominując, lecz wyraźnie wzbogacając jego złożoność.",
    color: "lime"
  },
  {
    id: "bisabolol",
    name: "α-Bisabolol",
    shortName: "Bisabolol",
    emoji: "🌼",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/d4c8fa1ef_389b069c3_JaowiecV115_96.png",
    scent: "Kwiatowy, miodowy, delikatny, rumiankowo-słodki",
    boilingPoint: 314,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Rumianek", "Candeia (drzewo brazylijskie)", "Szałwia", "Niektóre gatunki astru"],
    effects: [
      "Koi i łagodzi skórę",
      "Zmniejsza świąd — w badaniach na zwierzętach hamuje drapanie wywołane histaminą, czyli świąd taki jak w alergii i pokrzywce",
      "Przeciwzapalny — wycisza procesy zapalne w badaniach na zwierzętach i na ludzkich komórkach",
      "Wzmacnia działanie antybiotyków. Sam w sobie zwalcza gronkowca złocistego dopiero w stężeniach nieosiągalnych w organizmie, ale osłabia obronę bakterii — między innymi zdolność wypompowywania leku z komórki na zewnątrz, co zwiększa skuteczność antybiotyku",
      "Zmniejsza odczuwanie bólu, głównie w bólu związanym ze stanem zapalnym i neuropatycznym, nie działał natomiast na ból wywołany temperaturą",
      "Wspomaga gojenie ran. W niewielkim badaniu z udziałem 29 Pacjentów z przewlekłymi owrzodzeniami nóg preparat z bisabololem i oliwą ozonowaną wygoił ranę u co czwartego chorego",
      "Przeciwlękowy, co potwierdzono w badaniach na zwierzętach",
      "W badaniach na zwierzętach chroni komórki żołądka i nerek — żołądek przed uszkodzeniem po alkoholu i po lekach przeciwzapalnych, nerki przed niedokrwieniem i toksycznym działaniem niektórych leków, w tym używanych w chemioterapii. Ważne — podawano go, zanim doszło do uszkodzenia",
      "Chroni komórki nerwowe (w badaniach na zwierzętach), ale tylko te zdrowe, nie naprawia uszkodzonych",
      "Działa przeciwutleniająco. W badaniach na ludzkich komórkach odpornościowych ograniczał powstawanie szkodliwych form tlenu, które podtrzymują stan zapalny",
      "Uczula rzadko, ale może — opisano przypadki wysypki i zapalenia skóry po kosmetykach z bisabololem, zwłaszcza u osób uczulonych na rumianek, arnikę lub nagietek. Jeśli masz taką alergię, warto o tym pamiętać",
      "Rozjaśnia przebarwienia na skórze."
    ],
    description: "Bisabolol to terpen o długiej historii zastosowań — jako główny składnik olejku z rumianku towarzyszy ludzkości w medycynie i pielęgnacji skóry od wieków, a jego delikatny, kwiatowy aromat stał się synonimem łagodności i kojącego działania. W konopiach pełni rolę subtelnego składnika profilu aromatycznego, wnosząc kwiatową, lekko miodową nutę, która łagodzi ostrzejsze, żywiczne tony innych terpenów.",
    color: "pink"
  },
  {
    id: "nerolidol",
    name: "Trans-nerolidol",
    shortName: "Nerolidol",
    emoji: "🍊",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/201ca7542_9b0dea6d0_JaowiecV117_96.png",
    scent: "Kwiatowy, drzewny, cytrusowy z nutami kory i świeżości",
    boilingPoint: 277,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Jaśmin", "Trawa cytrynowa", "Imbir", "Drzewo herbaciane", "Lawenda", "Kwiat pomarańczy"],
    effects: [
      "Przeciwdrgawkowy, zmniejsza stres oksydacyjny w mózgu i działa neuroprotekcyjnie, np. w modelu choroby Parkinsona",
      "Wykazuje działanie przeciwlękowe w modelach zwierzęcych bez upośledzenia koordynacji ruchowej",
      "W warunkach in vitro hamuje wzrost bakterii, w tym szczepów wielolekoopornych, i zwiększa ich wrażliwość na antybiotyki",
      "Zmniejsza reakcje bólowe w bólu trzewnym i zapalnym, nie wpływa na próg bólu termicznego",
      "Przeciwzapalny",
      "Przeciwdepresyjny",
      "W badaniach na zwierzętach chronił błonę śluzową żołądka przed ostrym uszkodzeniem wywołanym etanolem, niesteroidowymi lekami przeciwzapalnymi, gdy był podany przed czynnikiem uszkadzającym"
    ],
    description: "Nerolidol to seskwiterpen o delikatnej, kwiatowo‑drzewnej woni, która wnosi do kompozycji zapachowych miękkość i głębię. Często bywa wykorzystywany w perfumerii i kosmetyce jako akord zapachowy nadający nutom zielonym i kwiatowym cieplejszy, bardziej otulający charakter. W badaniach laboratoryjnych wykazał także silne działanie przeciwbakteryjne, co sugeruje jego potencjał nie tylko jako składnika aromatycznego, lecz także jako związek o właściwościach biologicznych przydatnych w zastosowaniach terapeutycznych.",
    color: "rose"
  },
  {
    id: "guaiol",
    name: "Guaiol",
    shortName: "Guaiol",
    emoji: "🌳",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/3767f1cd4_4c661afbf_cypres_96.png",
    scent: "Drzewny, różany, sosnowy z delikatnymi nutami zielonymi",
    boilingPoint: 290,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Drewno gwajakowe (palo santo)", "Sosna cyprysowa"],
    effects: [
      "Zabija komórki raka płuca w badaniach laboratoryjnych i u myszy — u ludzi tego nie sprawdzano",
      "Zmniejsza stan zapalny w badaniach na komórkach i u zwierząt",
      "Hamuje wzrost grzybów rozkładających drewno — wobec grzybów chorobotwórczych dla człowieka nie był badany",
      "Odstrasza i zabija owady — to naturalna obrona rośliny, a nie działanie lecznicze",
      "Niszczy pasożyty wywołujące leiszmaniozę w badaniach na komórkach, nie uszkadzając przy tym komórek odpornościowych"
    ],
    description: "Guaiol to seskwiterpenowy alkohol o bogatej, żywiczno‑drzewnej nucie, po raz pierwszy wyizolowany z żywicy drzewa gwajakowego. W konopiach występuje stosunkowo rzadko, jednak dzięki swojemu charakterystycznemu aromatowi — ciepłemu, balsamicznemu z nutami sosny i skórzastej głębi — wyróżnia się w profilach zapachowych. Jest jednym z niewielu terpenów, które w temperaturze pokojowej są ciałem stałym, i wrze dopiero przy 290 °C, czyli znacznie powyżej temperatur waporyzacji. Oznacza to, że do pary przechodzi go niewiele, nawet jeśli w suszu jest go dużo.",
    color: "cyan"
  },
  {
    id: "farnezen",
    name: "β-Farnezen",
    shortName: "Farnezen",
    emoji: "🌾",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/f2afcd700_74c604319_JaowiecV110_96.png",
    scent: "Drzewny, zielony, lekko kwiatowy",
    boilingPoint: 261,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Jabłka", "Rumianek", "Nasiona kopru", "Imbir"],
    effects: [],
    description: "Farnezen to stosunkowo mało znany seskwiterpen o subtelnym, drzewno‑ziołowym aromacie, który często bywa pomijany w popularnych opisach profili zapachowych. Wykazuje się bardzo niską trwałością chemiczną — trzy wiązania podwójne czynią farnezen jednym z najszybciej utleniających się terpenów, co ma znaczenie dla przechowywania suszu, którego profil terpenowy będzie zmieniał się wraz z upływem czasu. Na ten moment o działaniu samego farnezenu wiemy bardzo niewiele, a większość właściwości przypisywanych mu w internecie należy do pokrewnego związku, farnezolu, i jest mylnie wiązana z tym terpenem.",
    color: "lime"
  },
  {
    id: "selinadien",
    name: "Selina-3,7(11)-diene",
    shortName: "Selinadien",
    emoji: "🌿",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/7dd2dab67_41057160a_JaowiecV19_96.png",
    scent: "Ziemisty, drzewny, lekko pikantny",
    boilingPoint: 270,
    boilingPointEstimated: true,
    hideDegradation: true,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Krwawnik pospolity", "Chmiel"],
    effects: [],
    description: "Selinadien to rzadki terpen, charakterystyczny dla odmian Kush Mints i Gastro Pop. Odpowiada za ich ziemisty, drzewny aromat z pikantną nutą. O tym, co robi w organizmie człowieka, nie wiemy praktycznie nic — nikt nie przebadał jeszcze jego dokładnego wpływu na organizm człowieka. Informacje o działaniu przeciwzapalnym czy uspokajającym, które można znaleźć w internecie, dotyczą w rzeczywistości innego, bardzo podobnego terpenu i pochodzą z badań całych olejków roślinnych. To nie znaczy, że selinadien nic nie robi — znaczy, że nikt tego (jeszcze) nie sprawdził.",
    color: "emerald"
  },
  {
    id: "eukaliptol",
    name: "Eucalyptol",
    shortName: "Eukaliptol",
    emoji: "🌿",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/57b9e43ca_76796ac08_JaowiecV11_96.png",
    scent: "Miętowy, ziemisty, zbliżony do kamfory",
    dateAdded: "2026-08-23",
    boilingPoint: 176,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Eukaliptus", "Piołun", "Rozmaryn", "Imbir"],
    effects: [
      "Zmniejsza stan zapalny u chorych na astmę i zmniejsza liczbę i nasilenie zaostrzeń POChP (przewlekłej obturacyjnej choroby płuc)",
      "Wykazuje działanie przeciwlękowe i poprawiające nastrój",
      "Pomaga przy ostrym zapaleniu oskrzeli i zatok — skuteczność sprawdzono w badaniach z udziałem Pacjentów",
      "Rozrzedza gęstą wydzielinę przy mokrym kaszlu, dzięki czemu łatwiej ją odkrztusić. Napady kaszlu słabną dlatego, że oskrzela się oczyszczają (nie dlatego, że eukaliptol wycisza sam odruch kaszlu)",
      "W badaniach na zwierzętach chroni pęcherzyki płucne przed dymem papierosowym: hamuje rozwój rozedmy i pomaga uszkodzonym płucom się odbudować",
      "Chronił mózg przed skutkami niedokrwienia, ale tylko wtedy, gdy podawano go przed, nie po zdarzeniu (brak badań wśród ludzi)",
      "Obniża poziom cukru na czczo, trójglicerydy i „zły” cholesterol LDL, a podnosi „dobry” HDL"
    ],
    description: "Eukaliptol (1,8-cyneol) to jeden z najbardziej rozpoznawalnych terpenów — jego świeży, miętowo-kamforowy aromat większość z nas kojarzy z olejkiem eukaliptusowym. Badania naukowe potwierdzają jego działanie przeciwzapalne oraz korzystny wpływ na układ oddechowy. W naturze występuje w eukaliptusie, rozmarynie, piołunie i imbirze.",
    color: "cyan"
  },
  {
    id: "cedren",
    name: "α-Cedren",
    shortName: "Cedren",
    emoji: "🌲",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/70d0eb26c_f9f154698_cedren_96.png",
    scent: "Ciepły, drzewny, lekko żywiczny",
    boilingPoint: 263,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Cedr atlaski (Cedrus atlantica)", "Jałowiec wirgiński (Juniperus virginiana)", "Dzika marchew"],
    effects: [
      "Zapobiega otyłości wywołanej dietą wysokotłuszczową i zmniejsza już rozwiniętą otyłość bez ograniczania ilości spożywanego pokarmu.",
      "Poprawia tolerancję glukozy i masę tkanki mięśniowej",
      "Nie działa uspokajająco, mimo ciepłego, drzewnego zapachu, który się z tym kojarzy — w badaniach na myszach cedren lęku nie zmniejszał. Za relaksujące działanie olejku cedrowego odpowiada inny związek z cedru, cedrol.",
      "Wykazuje słabą aktywność przeciwdrobnoustrojową w badaniach in vitro, nie badano go wobec bakterii ani grzybów istotnych klinicznie",
      "Brak danych dla działania przeciwzapalnego, przeciwbólowego i antyproliferacyjnego — efekty przypisywane cedrenowi pochodzą z badań całych olejków eterycznych, w których nie testowano go jako pojedynczego związku"
    ],
    description: "Seskwiterpen występujący naturalnie w olejku cedrowym (Cedrus atlantica, Juniperus virginiana), charakteryzujący się ciepłym, drzewnym, lekko żywicznym aromatem. W konopiach spotykany rzadko — w Polsce występuje tylko w dwóch odmianach, z czego w jednej z nich jest terpenem dominującym.",
    color: "amber"
  },
  {
    id: "walenzen",
    name: "Valencen",
    shortName: "Walenzen",
    emoji: "🍊",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/8b74e719d_a6617c6fb_walenzen_96.png",
    scent: "Intensywny, cytrusowy — słodki, pomarańczowy, lekko ziemisty",
    dateAdded: "2026-08-23",
    boilingPoint: 274,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Pomarańcze Valencia", "Mandarynki", "Klementynki", "Grejpfruty"],
    effects: [
      "Zmniejsza świąd i nasilenie zmian skórnych w atopowym zapaleniu skóry.  Przywraca też obniżony poziom filagryny, białka ważnego dla szczelności bariery naskórkowej.",
      "Przeciwgrzybiczy",
      "Chroni chrząstkę stawową. W chorobie zwyrodnieniowej stawu spowalnia jej postęp, co potwierdzono badaniem obrazowym stawu",
      "Wstępne dane laboratoryjne sugerują hamowanie wzrostu komórek nowotworowych, ale pochodzą głównie z symulacji komputerowych i prostych testów na komórkach. To zbyt wcześnie, by mówić o jakimkolwiek znaczeniu w leczeniu nowotworów"
    ],
    description: "Seskwiterpen o intensywnym, cytrusowym aromacie — słodki, pomarańczowy, lekko ziemisty. Naturalnie występuje w owocach Valencia (pomarańcze, mandarynki, klementynki, grejpfruty), skąd pochodzi jego nazwa. W profilu terpenowym konopi pojawia się jako składnik mniejszościowy, na ten moment dostępny w jednej odmianie w Polsce.",
    color: "orange"
  },
  {
    id: "geraniol",
    name: "(E)-Geraniol",
    shortName: "Geraniol",
    emoji: "🌹",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/57b62779a_606898614_JaowiecV118_96.png",
    scent: "Kwiatowy, różany, ze słodką nutą cytrusową",
    dateAdded: "2026-08-16",
    boilingPoint: 230,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Róża", "Pelargonia", "Trawa cytrynowa", "Cytronela", "Winogrona", "Tytoń"],
    effects: [
      "Zmniejsza ból — w bezpośrednim porównaniu czterech terpenów konopnych wypadł najsilniej, także w modelu bólu pooperacyjnego i fibromialgii. Działa przez receptory adenozynowe, czyli inaczej niż leki opioidowe",
      "Zmniejsza objawy zespołu jelita drażliwego, zmienia skład bakterii jelitowych na korzystniejszy",
      "Hepatoprotekcyjny — obniża aktywność enzymów wątrobowych, ogranicza jej włóknienie, a w stanach zapalnych spowalnia progresję zmian",
      "Przeciwbakteryjny i przeciwgrzybiczy",
      "Wstępne dane sugerujące właściwości kardioprotekcyjne",
      "Możliwe działanie ochronne na komórki nerwowe w stanach niedokrwiennych i przy deprywacji snu",
      "Aktywuje wewnętrzne mechanizmy antyoksydacyjne"
    ],
    description: "Geraniol to monoterpenowy alkohol o intensywnie różanym, kwiatowym aromacie, szeroko wykorzystywany w przemyśle perfumeryjnym i kosmetycznym. W konopiach występuje zwykle jako składnik poboczny, rzadko jako terpen dominujący, częściej towarzysząc limonenowi lub linalolowi w odmianach o profilu cytrusowo-kwiatowym.",
    color: "rose"
  },
  {
    id: "terpineol",
    name: "α-Terpineol",
    shortName: "Terpineol",
    emoji: "🌸",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/a6b09f6cb_8bcfec5c7_JaowiecV18_96.png",
    scent: "Sosnowy, kwiatowy, drzewny",
    dateAdded: "2026-08-23",
    boilingPoint: 217,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Cytrusy (limonka, pomarańcza)", "Sosna", "Eukaliptus", "Majeranek"],
    effects: [
      "Zmniejsza ból w badaniach na zwierzętach — zarówno ból zapalny, jak i ból wynikający z uszkodzenia nerwów oraz ból towarzyszący chorobie nowotworowej",
      "Zmniejsza stan zapalny",
      "Hamuje wzrost bakterii w warunkach laboratoryjnych, w tym bakterii odpowiedzialnych za próchnicę i choroby dziąseł",
      "Chroni śluzówkę żołądka",
      "Potencjalne działanie przeciwdepresyjne",
      "Przeciwbakteryjny"
    ],
    description: "Terpineol to monoterpenowy alkohol o delikatnym, wielowarstwowym aromacie łączącym nuty sosny, cytrusów i drewna, ceniony zarówno w perfumerii, jak i w przemyśle spożywczym oraz kosmetycznym. W konopiach występuje zazwyczaj jako składnik poboczny, rzadko dominujący, częściej towarzysząc innym terpenom. Badania potwierdzają jego działanie przeciwbólowe i przeciwzapalne, a najnowsze dane sugerują właściwości poprawiające nastrój, co mogłoby zwiększyć jego zastosowanie terapeutyczne w nadchodzących latach.",
    color: "purple"
  },
  {
    id: "borneol",
    name: "Borneol",
    shortName: "Borneol",
    emoji: "🌿",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/ee0524e15_90debfe19_Projektbeznazwy_96.png",
    scent: "Ziołowy, drzewny, kamforowy",
    dateAdded: "2026-08-23",
    boilingPoint: 212,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Drzewo z Borneo", "Kurkuma", "Tymianek", "Rozmaryn", "Imbir"],
    effects: [
      "Łagodzi świąd skóry",
      "Wycisza, ale nie usypia — w badaniach na zwierzętach zmniejsza lęk bez wywoływania senności",
      "Przeciwbólowy — w bólu neuropatycznym i zapalnym",
      "Pomaga innym substancjom przenikać barierę krew-mózg, ale też ułatwia penetrację nabłonka nosa, błony śluzowej nosa i wchłanianie przezskórne oraz jelitowe innym lekom",
      "Przeciwdrgawkowy",
      "Przeciwzapalny",
      "Wstępne dane sugerują działanie rozszerzające naczynia krwionośne i obniżające ciśnienie tętnicze krwi",
      "Ułatwia przenikanie bariery krew-mózg"
    ],
    description: "Borneol to terpen minorowy w konopiach, znany przede wszystkim z kurkumy, tymianku i imbiru. Jego kamforowy, ziołowy aromat od wieków towarzyszy tradycyjnej medycynie chińskiej, gdzie stosowano go jako analgetyk w formie suchego proszku. Współczesna nauka odkryła w borneolu coś znacznie ciekawszego niż tradycyjne działanie przeciwbólowe - pomaga on w penetracji bariery krew-mózg innym lekom. W konopiach pomaga odróżnić jedne odmiany od drugich - analizie 33 odmian borneol okazał się jednym z pięciu składników zapachowych, które wyraźnie różnicują odmiany o przewadze THC od odmian o przewadze CBD.",
    color: "cyan"
  },
  {
    id: "fitol",
    name: "Phytol",
    shortName: "Fitol",
    emoji: "🍃",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/ff4973b72_ce82d181e_JaowiecV17_96.png",
    scent: "Kwiatowy, jaśminowy, balsamiczny",
    dateAdded: "2026-08-23",
    boilingPoint: 203,
    boilingPointNote: true,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Jaśmin", "Zielona herbata", "Drzewo oliwne", "Sałata", "Kurkuma"],
    effects: [
      "Uspokajający i anksjolityczny (przeciwlękowy), potwierdzone działanie wydłużające sen",
      "Przeciwzapalny — w badaniach na zwierzętach zmniejsza obrzęk i bolesność stawów",
      "Przeciwbólowy — łagodził różne rodzaje bólu, w tym ból migrenowy",
      "Wykazuje właściwości przeciwdrgawkowe"
    ],
    warning: "Wdychany fitol powoduje ciężkie uszkodzenie płuc u szczurów — martwica, obrzęk, krwotoki, zapalenie, spadek masy ciała i zgony po jednym–dwóch dniach ekspozycji. Badanie zaprojektowano wprost pod produkty do waporyzacji, bo fitol bywa dodawany do wkładów z kannabinoidami jako rozcieńczalnik. Autorzy nie ustalili bezpiecznego zakresu ekspozycji i odradzają jego stosowanie.",
    warningEn: "Inhaled phytol causes severe lung injury in rats — necrosis, oedema, haemorrhage, inflammation, weight loss and deaths after one to two days of exposure. The study was designed specifically around vaporisation products, because phytol is sometimes added to cannabinoid cartridges as a diluent. The authors did not establish a safe exposure range and advise against its use.",
    description: "Fitol to terpen, który w naturze występuje najobficiej jako fragment cząsteczki chlorofilu — barwnika nadającego liściom zielony kolor i niezbędnego w procesie fotosyntezy. Gdy chlorofil ulega rozkładowi uwalnia fitol stanowiący ok. 30% jego masy. Izolacja tego terpenu została nagrodzona nagrodą Nobla w 1914 roku, ale jego historia jest znacznie starsza - od setek lat tradycyjna medycyna chińska i Ayurveda promowała stosowanie jaśminu i kurkumy, bogatych w fitol. W latach 50 XX wieku pochodna chlorofilu trafiła na półki aptek jako środek na gojenie ran, a współczesna nauka zwraca uwagę na jego potencjał przeciwcukrzycowy, przeciwnowotworowy oraz przeciwbólowy i potencjalne zastosowanie w terapii zaburzeń lękowych czy epilepsji.",
    color: "green"
  },
  {
    id: "sabinen",
    name: "Sabinen",
    shortName: "Sabinen",
    emoji: "🥕",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/9340e45be_0726a10a7_JaowiecV17_96.png",
    scent: "Ciepły, korzenny, pikantny z nutami drewna i ziemi",
    dateAdded: "2026-09-13",
    boilingPoint: 163,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Dzika marchew", "Jałowiec", "Pieprz", "Piołun"],
    effects: [
      "Chroni stawy - podawany doustnie zmniejsza obrzęk łap, stan zapalny i stres oksydacyjny w modelu chorób zapalnych stawów. Podawanie rozpoczęto przed wywołaniem choroby, dlatego wyniki dotyczą działania ochronnego, nie leczenia już rozwiniętego zapalenia.",
      "Przeciwzapalny",
      "Antyoksydacyjny — zmniejsza uszkodzenie komórek przez wolne rodniki i przywraca aktywność własnych enzymów ochronnych",
      "Neuroprotekcyjny",
      "Chroni mięśnie przed zanikiem — u głodzonych szczurów ograniczał zanik włókien mięśniowych",
      "Hamuje rozwój raka wątroby — w badaniach przedklinicznych zmniejsza częstość guzów i wywołuje śmierć komórek nowotworowych, nie uszkadzając prawidłowych hepatocytów; nie potwierdzono skuteczności u ludzi"
    ],
    description: "Sabinen to bicykliczny monoterpen o ciepłym, korzennym aromacie, którego nazwa wywodzi się od jałowca sabińskiego (Juniperus sabina) — a jednym z najbogatszych źródeł sabinenu jest olejek z nasion dzikiej marchwi, gdzie stanowi około jednej czwartej składu. W tradycyjnej medycynie chińskiej olejek z nasion dzikiej marchwi stosowano od wieków na choroby pasożytnicze, a w europejskiej fitoterapii na stany zapalne dróg moczowych i prostaty.",
    color: "orange"
  },
  {
    id: "kamfen",
    name: "Kamfen",
    shortName: "Kamfen",
    emoji: "🌲",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/a6256e17f_719cb3128_JaowiecV16_96.png",
    scent: "Ziemisty, kamforowy, sosnowy z nutami mchu",
    dateAdded: "2026-09-13",
    boilingPoint: 159,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Jałowiec", "Olej kamforowy", "Gałka muszkatołowa", "Rozmaryn", "Waleriana", "Świerk"],
    effects: [
      "Przeciwbólowy — hamuje ból zapalny i neuropatyczny poprzez blokowanie kanałów wapniowych",
      "Zwiększa wrażliwość tkanek na insulinę",
      "Działanie kardioprotekcyjne, ochrania mięsień sercowy przed uszkodzeniami niedokrwiennymi",
      "Obniża cholesterol i trójglicerydy w mechanizmie odmiennym od statyn",
      "Ogranicza stłuszczenie wątroby",
      "Po podaniu podskórnym i dootrzewnowym znacząco łagodzi świąd skóry",
      "Przeciwzapalny"
    ],
    description: "Kamfen to rzadszy terpen konopi — występuje w mniejszych stężeniach niż mircen czy limonen, co nie umniejsza szerokości jego działania. To bicykliczny monoterpen o charakterystycznym ziemisto-kamforowym aromacie, nadający profilom mszystą, leśną głębię. Wyróżnia się przede wszystkim wpływem na układ sercowo-naczyniowy — badania wykazują, że obniża cholesterol i trójglicerydy mechanizmem odmiennym od statyn, a badanie z 2024 roku udokumentowało jego działanie kardioprotekcyjne — ochronę tkanki sercowej przed uszkodzeniem niedokrwiennym. Naturalnie występuje w olejku z jałowca, kamfory, gałki muszkatołowej, rozmarynu i waleriany. W medycynie tradycyjnej olejki bogate w kamfen — z szałwii i waleriany — cenione były za działanie uspokajające, a sam kamfen często trafia do topikalnych maści konopnych na łuszczycę i egzemę.",
    color: "stone"
  },
  {
    id: "bulnesol",
    name: "Bulnesol",
    shortName: "Bulnesol",
    emoji: "🌳",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/82b5035f3_9c60b9cc0_JaowiecV119_96.png",
    scent: "Balsamiczny, lekko korzenny",
    dateAdded: "2026-08-25",
    boilingPoint: 290,
    boilingPointEstimated: true,
    boilingPointIsomerNote: true,
    hideDegradation: true,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Drzewo gwajakowe"],
    effects: [
      "Przeciwgrzybiczy wobec grzybów niszczących drewno, nie badano grzybów chorobotwórczych dla człowieka",
      "Potencjalne działanie przeciwzapalne zbliżone do diklofenaku",
      "Stabilny w temperaturach używanych przy waporyzacji — dopiero powyżej około 275 °C przekształca się w elemol, czyli zupełnie inny terpen",
      "Działania przeciwbólowego samego bulnesolu nigdy nie badano — przypisuje się je olejkowi z drzewa gwajakowego jako całości, nie temu jednemu składnikowi"
    ],
    description: "Bulnesol to izomer guaiolu - związek chemiczny z grupy seskwiterpenów, występujący naturalnie w olejku z drzewa gwajakowego, któremu nadaje balsamiczny, lekko korzenny aromat. To właśnie dzięki niemu znalazł on zastosowanie w kosmetyce i perfumiarstwie, jest też doceniany ze względu na przypisywane mu właściwości wyciszające w aromaterapii (choć nie potwierdzono ich w badaniach). Rzadkość w profilu terpenowym, na chwilę obecną deklarowany w jednej odmianie dostępnej w Polsce.",
    color: "cyan"
  },
  {
    id: "fenchol",
    name: "Fenchol",
    shortName: "Fenchol",
    emoji: "🌿",
    image: "https://base44.app/api/apps/69e561e7a8d8686b80fb4d20/files/mp/public/69e561e7a8d8686b80fb4d20/a18058d24_e4fbce5e6_Projektbeznazwy1_96.png",
    scent: "Ziemisty, sosnowy, mentolowy",
    dateAdded: "2026-09-13",
    boilingPoint: 202,
    boilingPointUnit: "°C",
    naturalOccurrence: ["Liście bazylii", "Koper włoski", "Eukaliptus", "Limonka", "Sosna"],
    effects: [
      "Ochronny dla komórek nerwowych — w badaniach na komórkach nerwowych i na zwierzętach fenchol pomagał usuwać z mózgu białko, które odkłada się w chorobie Alzheimera (u ludzi tego nie sprawdzano)",
      "Przeciwbakteryjny — w warunkach laboratoryjnych hamował wzrost wielu różnych bakterii, działał jednak wyraźnie słabiej niż penicylina i nie zastąpi leczenia",
      "Może powstawać podczas waporyzacji — w pomiarach w temperaturach zbliżonych do waporyzacji fenchol pojawiał się jako produkt przemiany innych terpenów. Jego ilość w parze nie musi więc odpowiadać temu, co widnieje w wyniku badania suszu"
    ],
    description: "Nietypowy wśród terpenów konopnych, ponieważ w temperaturze pokojowej jest niskotopliwym ciałem stałym o barwie białej do bladożółtej, a nie cieczą. W konopiach należy do terpenów drugorzędowych: pojawia się w niewielkich stężeniach i nigdy nie dominuje w profilu odmiany.",
    color: "slate"
  }
];

export function getTerpeneByShortName(shortName) {
  return TERPENES.find(
    t => t.shortName.toLowerCase() === shortName.toLowerCase()
  ) || null;
}